/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";

export const getCommits = () => {
  return API.get(`${process.env.REACT_APP_API_URL}/api/k3commit/list`);
}

export const getCommit = (id) => {
  return API.get(`${process.env.REACT_APP_API_URL}/api/k3commit/get/${id}?get_message=true&get_doc=true`);
}

export const updateCommit = (id, commitData) => {
  return API.put(`${process.env.REACT_APP_API_URL}/api/k3commit/update/${id}`, commitData);
}

export const commitService = {
  getCommits,
  getCommit,
  updateCommit
} 